export default __webpack_public_path__ + "static/media/money-protection.754d25af.svg";